import AccessRequest from "@/views/accessRequest/AccessRequest.vue";
import type { RouterOptions } from "vue-router";
import ConstructionProjectAccessRequest from "./ConstructionProjectAccessRequest.vue";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  stationarySource: "AccessRequest.stationarySource",
  constructionProject: "AccessRequest.constructionProject",
};

export { names as accessRequestRouteNames };

const accessRequestRoutes: RouterOptions["routes"] = [
  {
    path: "/stationary-source-access-request",
    name: names.stationarySource,
    meta: { title: "New Stationary Source Access Request", isNew: true },
    component: {
      render: () => <AccessRequest entityLabel="Stationary Source" entityName="Stationary Source" />,
    },
  },
  {
    path: "/construction-project-access-request",
    name: names.constructionProject,
    meta: { title: "New Construction Project Access Request", isNew: true },
    component: {
      render: () => <ConstructionProjectAccessRequest />,
    },
  },
];
export default accessRequestRoutes;
